<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9998 11.0625C11.9998 11.3111 12.0986 11.5496 12.2744 11.7254C12.4502 11.9012 12.6887 12 12.9373 12C13.186 12 13.4244 11.9012 13.6002 11.7254C13.7761 11.5496 13.8748 11.3111 13.8748 11.0625C13.8748 10.8139 13.7761 10.5754 13.6002 10.3996C13.4244 10.2238 13.186 10.125 12.9373 10.125C12.6887 10.125 12.4502 10.2238 12.2744 10.3996C12.0986 10.5754 11.9998 10.8139 11.9998 11.0625ZM20.6014 19.3336L16.3194 8.25V4.17188H17.9998V2.57812H5.99983V4.17188H7.6803V8.25L3.39827 19.3336C3.33264 19.507 3.29749 19.6898 3.29749 19.875C3.29749 20.7023 3.97014 21.375 4.79749 21.375H19.2022C19.3873 21.375 19.5701 21.3398 19.7436 21.2742C20.517 20.9766 20.9014 20.107 20.6014 19.3336V19.3336ZM9.27405 8.54766V4.21875H14.7256V8.54766L16.8561 14.0625C16.3709 13.9383 15.8694 13.875 15.3584 13.875C13.924 13.875 12.5647 14.3789 11.4842 15.2812C10.6868 15.9474 9.68031 16.3117 8.64124 16.3102C7.87483 16.3102 7.13889 16.1156 6.48967 15.7547L9.27405 8.54766V8.54766ZM4.93342 19.7812L5.91077 17.2547C6.74749 17.6789 7.67795 17.9062 8.64358 17.9062C10.078 17.9062 11.4373 17.4023 12.5178 16.5C13.3123 15.8391 14.3061 15.4711 15.3608 15.4711C16.1811 15.4711 16.9639 15.6938 17.6483 16.1063L19.0662 19.7812H4.93342Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Experiment' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
